module.exports = __webpack_public_path__ + "static/media/lolol_cash_voucher.86652b97.png";